class AccountSettings.AttributeValidationRulesView extends Backbone.View
  template: JST['backbone/templates/account_settings/ticket_validation_rules/attribute_validation_rules']
  tagName: 'li'
  className: 'validation-rule'

  events:
    'click': '_onCheckboxClick'

  initialize: ({attributeValidationRules}) ->
    @attributeValidationRules = attributeValidationRules

  render: ->
    @$el.html(@template({
      name: @attributeValidationRules.get('name')
      code: @attributeValidationRules.get('code')
      isChecked: @attributeValidationRules.get('presence_validation')
    }))
    @

  toggleChecked: (isChecked) =>
    @_checkbox().prop('checked', isChecked)
    @_saveChekedState(isChecked)

  _onCheckboxClick: (event) ->
    @toggleChecked(!@attributeValidationRules.get('presence_validation'))

  _saveChekedState: (isChecked) ->
    @attributeValidationRules.set('presence_validation', isChecked)

  _checkbox: ->
    @$('.checkbox-icon')
